import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import env from "../../assets/img/env.png";
import safty from "../../assets/img/safty.png";
import csr from "../../assets/img/csr.png";

class HomePage extends Component {
  render() {
    return (
      <>
        <div className="container-fluid container_gray">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-lg-1">&nbsp;</div>
              <div className="col-lg-10 col-sm-12 event slide-left top in-view">
                <h3>Customer Registration Portal</h3>
                <div className="border_page"> </div>
                <p>
                  Customer Registration Portal For AM/NS India Steel Limited
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid container_gray">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-lg-1">&nbsp;</div>
              <div className="col-lg-10 col-sm-12 event slide-left top in-view">
                <h3>Products and Services</h3>
                <div className="border_page"> </div>
                <p>
                  AM/NS India strives for distinction in each of our market
                  segments. Our efforts to achieve excellence in the quality and
                  value of our products derives from an uncompromising quality
                  control over the entire steel making process, from the
                  acquisition of raw materials to the finished product, and
                  across our supply chain.
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-1">&nbsp;</div>
              <div className="col-lg-10 col-sm-12">
                <div className="row">
                  <div className="col-lg-2"></div>
                  <div className="col-lg-4 col-sm-6 mb-3 event slide-left even">
                    <div className="home_banner_products section_product"></div>
                    <div className="text_overlay_img even_txt">
                      <span className="text-left-banner">Products </span>
                      <a
                        href="products/products/Products/"
                        className="text-right-banner"
                      >
                        Know more &gt;&gt;
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 mb-3 event slide-left odd">
                    <div className="home_banner_industry section_product"></div>
                    <div className="text_overlay_img">
                      <span className="text-left-banner">
                        Industry Segments
                      </span>
                      <a
                        href="products/products/Industry Segments/"
                        className="text-right-banner"
                      >
                        Know more &gt;&gt;
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid container_white">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-lg-1">&nbsp;</div>
              <div className="col-lg-10 col-sm-12 event slide-left top in-view">
                <h3>Sustainability</h3>
                <div className="border_page"> </div>
                <p>
                  We are committed to making a positive impact for all our
                  stakeholders – our business partners, customers and employee.{" "}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-1">&nbsp;</div>
              <div className="col-lg-10 col-sm-12 ">
                <div className="row">
                  <div className="col-lg-1">&nbsp;</div>
                  <div className="col-lg-10 col-sm-12 mt-3">
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-sm-12 event slide-left even in-view">
                        <div className="icon_sustain">
                          <img
                            src={safty}
                            className="img-fluid"
                            alt="Safty"
                          />
                        </div>
                        <h5 className="text_align mt-2">Safety</h5>
                        <p className="sustain_text">
                          Safety is our highest priority. Our safety standards
                          and performance exceed the industry average, a badge
                          of honor for the company and for each of our
                          employees.
                        </p>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12 event slide-left bottom in-view">
                        <div className="icon_sustain">
                          <img
                            src={env}
                            className="img-fluid"
                            alt="Safty"
                          />
                        </div>
                        <h5 className="text_align mt-2">Environment</h5>
                        <p className="sustain_text">
                          We will work to implement the highest environmental
                          standards in Indian steelmaking.
                        </p>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-12 event slide-left odd in-view">
                        <div className="icon_sustain">
                          <img
                            src={csr}
                            className="img-fluid"
                            alt="Safty"
                          />
                        </div>
                        <h5 className="text_align mt-2">CSR</h5>
                        <p className="sustain_text">
                          We are committed to the communities in which we
                          operate and that is why our corporate social
                          responsibility is as strategic as our steel making.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(HomePage);
